export default "__VITE_ASSET__BwPFmlzy__"